import { ToggleSwitch } from "flowbite-react";
import { useState } from "react";

const DefaultToggleInput = ({
    label,
    isChecked,
    onChange,
    headLabel
}) => {

    return (
        <div className="toggleSwitch">
            <label
                className={`text-theme font-medium text-sm`}
            >
                {headLabel ? headLabel : ""}
            </label>
            <ToggleSwitch className="shadow-none" checked={isChecked} label={label} onChange={onChange} />
        </div>
    )
}

export default DefaultToggleInput;